module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/ainsley-abbitt-a633dfb0d7c8dd72620fe6305b708c33.jpg";